import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Element from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import en from '../../public/lang/en'
import zh from '../../public/lang/zh'
import store from '../store'

Vue.use(VueI18n)


const messages = {
  en: {
    message: 'en',
    ...enLocale,
    ...en // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
  zh: {
    message: 'zh',
    ...zhLocale,
    ...zh // 或者用 Object.assign({ message: '你好' }, zhLocale)
  }
}
// 设置默认语言为英文
const i18n = new VueI18n({
  locale: store.getters.language,
  messages,
  silentTranslationWarn: true
})

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export default i18n

export {en, zh}